import { Typography, Box } from '@mui/material'
import { makeStyles } from '@mui/styles'

type Props = {
  text: string
  color?: 'primary' | 'secondary'
}
const useStyles = makeStyles(() => ({
  contentSubTitle: {
    fontSize: 13,
  },
}))

export const ContentSubTitle: React.FC<Props> = (props) => {
  const classes = useStyles(props)

  return (
    <Box m={1}>
      <Typography className={classes.contentSubTitle} display="inline">
        {props.text}
      </Typography>
    </Box>
  )
}
